<template>
  <div v-if="plugins.length" class="plugin-summary p-3">
    <table class="plugin-list border-bottom">
      <tbody>
        <tr v-for="plugin in plugins">
          <td>
            <img v-lazy="getPluginThumbUrlFromObject(plugin)" width="30px" class="mb-2 mr-3" />
          </td>
          <td>
            <router-link :to="{ name: 'pluginDetails', params: { pluginKey: plugin.pluginKey } }">
              <span v-html="plugin.name" />
            </router-link>
          </td>
          <td>
            <router-link :to="{ name: 'pluginDetails', params: { pluginKey: plugin.pluginKey } }">
              {{ plugin.installCount }}
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import _ from 'lodash';
import { getPluginThumbUrlFromObject } from '@/libs/plugin/getPluginThumbUrlFromObject';

const placeholderImage = process.env.VUE_APP_PLUGIN_PLACEHOLDER_IMAGE_URL;

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: placeholderImage,
  loading: placeholderImage,
  attempt: 1,
});

export default {
  components: {},
  props: {
    pluginSummary: Array,
  },
  computed: {
    plugins() {
      return _.orderBy(this.pluginSummary, ['installCount'], ['desc']);
    },
  },
  methods: {
    getPluginThumbUrlFromObject,
    getPluginKey(plugin) {
      return plugin.pluginKey;
    },
  },
};
</script>

<style lang="scss" scoped="">
.c-dark-theme {
  .plugin-summary {
    background-color: #23242d;
  }
}

.plugin-summary {
  height: calc(100vh - 280px);
  margin-bottom: 10px;
  overflow-x: auto;
  font-size: 12px;
}
</style>
